// Add your custom JS here.

// Reveal Text
gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray(".revealUp").forEach(function (elem) {
    ScrollTrigger.create({
        trigger: elem,
        start: "top 80%",
        end: "bottom 20%",
        //markers: true,
        once: true,
        onEnter: function () {
            gsap.fromTo(
                elem,
                { y: 100, autoAlpha: 0 },
                {
                    duration: 1.25,
                    y: 0,
                    autoAlpha: 1,
                    ease: "back",
                    overwrite: "auto"
                }
            );
        },
    });
});

// Carousel - Quotes
document.addEventListener("DOMContentLoaded", function () {
    const carousel = document.querySelector(".carousel-quotes");
    if (!carousel) return;

    const innerContainer = carousel.querySelector(".carousel-inner");
    const slides = carousel.querySelectorAll(".carousel-item");

    function normalizeSlideHeights() {
        let tallestHeight = 0;

        // 1. Reset explicit heights to read natural layout dimensions safely
        slides.forEach((slide) => {
            slide.style.display = "block"; // Temporarily display to calculate accurate dimensions
            slide.style.height = "auto";
        });

        // 2. Scan items to determine the maximum height requirement
        slides.forEach((slide) => {
            const currentHeight = slide.offsetHeight;
            if (currentHeight > tallestHeight) {
                tallestHeight = currentHeight;
            }
        });

        // 3. Clear the temporary style override
        slides.forEach((slide) => {
            slide.style.display = "";
        });

        // 4. Set the uniform target dimension across all slides and the main wrapper
        if (tallestHeight > 0) {
            innerContainer.style.height = tallestHeight + "px";
            slides.forEach((slide) => {
                slide.style.height = tallestHeight + "px";
            });
        }
    }

    // Execute on initial paint load
    setTimeout(normalizeSlideHeights, 200);

    // Recalculate dimensions dynamically if the screen scales or breaks layout points
    window.addEventListener("resize", normalizeSlideHeights);
});
